import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Container } from "react-bootstrap";
import LeftArrow from "./components/LeftArrow";
import RightArrow from "./components/RightArrow";
import style from "./collaborator.module.css";

function Collaboratorr() {
  const logos = [
    "avabox-logo.jpg",
    "avapeyma-logo.jpg",
    "dekapost-logo.jpg",
    "mahex-logo.jpg",
    "post-logo.jpg",
    "rabar-logo.jpg",
    "saman-logo.jpg",
    "tipax-logo.jpg",
    "chapar-logo.jpg",
  ];

  const responsive = {
    mobile: {
      breakpoint: { max: 576, min: 0 },
      items: 2,
    },
    tablet: {
      breakpoint: { max: 768, min: 576 },
      items: 3,
    },
    miniDesktop: {
      breakpoint: { max: 1200, min: 768 },
      items: 4,
    },
    desktop: {
      breakpoint: { max: 4000, min: 1200 },
      items: 5,
    },
  };

  return (
    <Container>
      <div className="text-center">
        <img style={{ width: 300, height: 300 }} src="/ourPartners.png" />
      </div>

      <Carousel
        responsive={responsive}
        customRightArrow={<RightArrow />}
        customLeftArrow={<LeftArrow />}
        renderArrowsWhenDisabled={true}
        autoPlay={true}
        autoPlaySpeed={2000}
        infinite={true}
        className={style.list}
      >
        {logos.map((item, idx) => (
          <div key={idx}>
            <div className="d-flex align-items-center justify-content-center">
              <img
                src={"/collaborator/" + item}
                style={{ maxWidth: "130px", userSelect: "none" }}
                draggable="false"
              />
            </div>
          </div>
        ))}
      </Carousel>
    </Container>
  );
}

export default Collaboratorr;
